import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 text-center px-4">
      <FileQuestion className="h-12 w-12 text-slate-300" aria-hidden="true" />
      <div>
        <h1 className="text-3xl font-bold text-slate-800">404</h1>
        <p className="mt-1 text-base font-medium text-slate-600">Page not found</p>
        <p className="mt-1 text-sm text-slate-400">
          The page you're looking for doesn't exist or has been moved.
        </p>
      </div>
      <Link
        to="/"
        className="mt-2 text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}
